import type { RootState } from '@src/store/reduxstore';

export const channelsSelector = (state: RootState) =>
  state.channels.data.channels;

export const channelsCountSelector = (state: RootState) =>
  state.channels.data.count;

export const channelsRequestStatusSelector = (state: RootState) =>
  state.channels.request.status;

export const channelsRequestErrorSelector = (state: RootState) =>
  state.channels.request.error;
